import React, { useEffect, useState } from "react";
import Product from "@system/config/product";
import $ from "jquery";
import Helper from 'src/helper/Helper';
import { useProductStore } from 'src/hooks/product';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import System from 'src/helper/system';
const ProductDetailDescriptionTab = (props) => {
  const { productDetail } = props;
  const [{ }, { }, { }] = useProductStore();
  const [productData, setProductData] = useState([]);
  const [ECCNData, setECCNData] = useState([]);
  const [ascDesField, setAscDesField] = useState({});
  const [sortBy, setSortBy] = useState("");
  const [selectedValues, setSelectedValues] = useState({});
  const [{ inventoryList, pricing_list }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
  const inventory = inventoryList;
  const pricingList = pricing_list;

  const goToProductListing = () => {
    let encodedUrl = btoa(JSON.stringify(selectedValues));
    window.location.href = Product.getProductListingPageRouteURL() + '?' + $.param({
      go: encodedUrl,
      appendFacadeOptions: 'yes'
    });
  };

  useEffect(() => {
    if (productDetail?.Attributes && productDetail?.Attributes.length > 0) {
      setProductData(productDetail.Attributes);
    }

    if (productDetail) {
      const ECCNInfo = [];
      if (productDetail?.sap_originating_countryoforigin) {
        const ECCNObj = {};
        ECCNObj.Name = "Country of Origin";
        ECCNObj.Value = productDetail.sap_originating_countryoforigin;
        ECCNInfo.push(ECCNObj);
      }
      if (productDetail?.ECCNCode) {
        const ECCNObj = {};
        ECCNObj.Name = "ECCN";
        ECCNObj.Value = productDetail.ECCNCode;
        ECCNInfo.push(ECCNObj);
      }
      if (productDetail?.HTSCode) {
        const ECCNObj = {};
        ECCNObj.Name = "HTSN";
        ECCNObj.Value = productDetail.HTSCode;
        ECCNInfo.push(ECCNObj);
      }
      if (productDetail?.ScheduleBCode) {
        const ECCNObj = {};
        ECCNObj.Name = "Schedule B";
        ECCNObj.Value = productDetail.ScheduleBCode;
        ECCNInfo.push(ECCNObj);
      }
      if (productDetail?.UNSPSCVersionCode) {
        const ECCNObj = {};
        ECCNObj.Name = "UNSPSC Version";
        ECCNObj.Value = productDetail.UNSPSCVersionCode;
        ECCNInfo.push(ECCNObj);
      }
      if (productDetail?.UNSPSCCode) {
        const ECCNObj = {};
        ECCNObj.Name = "UNSPSC";
        ECCNObj.Value = productDetail.UNSPSCCode;
        ECCNInfo.push(ECCNObj);
      }
      setECCNData(ECCNInfo);
    }
  }, [productDetail]);

  const sortAttributes = (columnName) => {
    const Attributes =
      columnName === "Name" || columnName === "Value"
        ? [...ECCNData]
        : [...productData];
    let AttributesSorted = [];
    if (ascDesField.hasOwnProperty(columnName)) {
      ascDesField[columnName] =
        ascDesField[columnName] === "ASC" ? "DESC" : "ASC";
      setAscDesField(ascDesField);
    } else {
      ascDesField[columnName] = "ASC";
      setAscDesField(ascDesField);
    }
    setSortBy(columnName);
    if (ascDesField[columnName] === "ASC") {
      AttributesSorted = Attributes.sort((a, b) =>
        b[columnName] < a[columnName] ? -1 : 1
      );
    } else if (ascDesField[columnName] === "DESC") {
      AttributesSorted = Attributes.sort((a, b) =>
        b[columnName] > a[columnName] ? -1 : 1
      );
    }
    // Working Not working, Will continue.
    if (columnName === "Name" || columnName === "Value") {
      setECCNData(AttributesSorted);
    } else {
      setProductData(AttributesSorted);
    }
  };

  const getOrderByClass = (columnName) => {
    if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
      return "sorting sorting_" + ascDesField[columnName].toLowerCase();
    }
    return "sorting";
  };

  //By Ramya Kannan [Product view - Adobe script ]

  const [isProdViewEvent, setProdViewEvent] = useState(true);
  useEffect(() => {
    let checkCon =
      productDetail &&
      isProdViewEvent &&
      Object.keys(inventory).length &&
      System.checkPriceValues(pricingList);
    if (checkCon) {
      prodViewEvent();
      setProdViewEvent(false);
    }
  }, [productDetail, inventory, pricingList]);


  function prodViewEvent() {
    localStorage.setItem("adobeEventType", "productViewEvent");
    let prodDetails = { ...productDetail };
    prodDetails.qas = get_inventory_by_id(prodDetails.ItemNumber)?.inventoryQty || 0;
    let pricingDetails = getPricing(prodDetails);
    prodDetails.priceSource = pricingDetails?.priceSource;
    prodDetails.unitPrice = prodDetails.unitPrice || pricingDetails?.marketPrice;
    prodDetails.subtotal = prodDetails.subtotal || (pricingDetails?.marketPrice * pricingDetails?.quantity);
    prodDetails.quantity = prodDetails.Quantity || pricingDetails?.quantity;
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails });
    }
  }


  //added by Ramya [Adobe script]
  const getPricing = (ele) => {
    //   const getPricing = () => {
    //     return get_pricing_by_id({ ItemNumber: productDetail.ItemNumber })
    // };
    let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
    return priceValues && priceValues[0];
  }

  const handleRowCheckboxChange = (row) => {
    setSelectedValues((prevSelectedValues) => {
      const newSelectedValues = { ...prevSelectedValues };
      const rowKey = Helper.anythingToCamel(row.main_label);
      const rowValue = row.value;

      if (newSelectedValues[rowKey]) {
        const valueIndex = newSelectedValues[rowKey].s.findIndex(item => item.value === rowValue);
        if (valueIndex !== -1) {
          newSelectedValues[rowKey].s.splice(valueIndex, 1);
          if (newSelectedValues[rowKey].s.length === 0) {
            delete newSelectedValues[rowKey];
          }
        } else {
          newSelectedValues[rowKey].s.push({ value: rowValue });
        }
      } else {
        newSelectedValues[rowKey] = { s: [{ value: rowValue }], main_label: row.main_label };
      }

      return newSelectedValues;
    });
  };

  const handleSelectAllCheckboxChange = () => {
    if (Object.keys(selectedValues).length === productData.length) {
      setSelectedValues({});
    } else {
      const allValues = productData.reduce((acc, item) => {
        const key = Helper.anythingToCamel(item.ATTRNAME);
        if (!acc[key]) {
          acc[key] = { s: [{ value: item.ATTRVAL }], main_label: item.ATTRNAME };
        } else {
          acc[key].s.push({ value: item.ATTRVAL });
        }
        return acc;
      }, {});
      setSelectedValues(allValues);
    }
  };

  const isAllSelected = Object.keys(selectedValues).length === productData.length;

  return (
    <>
      <div className="tab-pane active" id="tab1">
        <div className="productdetail-description">
          {productDetail?.LongDescription ? (
            <p
              className="mob-font-13 mb-2"
              dangerouslySetInnerHTML={{
                __html: productDetail.LongDescription,
              }}
            ></p>
          ) : (
            ""
          )}

          {productDetail.ProductFeatures ? (
            <p
              className="mob-font-13 mb-2"
              dangerouslySetInnerHTML={{
                __html: productDetail.ProductFeatures,
              }}
            ></p>
          ) : (
            ""
          )}
        </div>

        {productData && productData.length > 0 && (
          <div className="">
            <h3 className="mb-2 mt-0 lh-normal">Technical Attributes</h3>
            <p className="text-sm mb-2">Find Similar Parts</p>
            {productDetail?.Attributes && productDetail?.Attributes.length > 0 ? (
              <div className="table-responsive">
                <table className="bs5 table table-bordered">
                  <thead>
                    <tr>
                      <th className="w35 font-12">
                        <div className="form-check d-flex align-items-center font-18">
                          <input
                            type="checkbox"
                            className="form-check-input  me-1"
                            id="productDetailAttribute"
                            checked={isAllSelected}
                            onChange={handleSelectAllCheckboxChange}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="productDetailAttribute"
                          />
                        </div>
                      </th>
                      <th>
                        <span>Description</span>
                        <span
                          className={
                            "sort-container " + getOrderByClass("ATTRNAME")
                          }
                          onClick={() => {
                            sortAttributes("ATTRNAME");
                          }}
                        ></span>
                      </th>
                      <th>
                        <span>Value</span>
                        <span
                          className={
                            "sort-container " + getOrderByClass("ATTRVAL")
                          }
                          onClick={() => {
                            sortAttributes("ATTRVAL");
                          }}
                        ></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {productData.map((element, index) => {
                      const row = {
                        key: Helper.anythingToCamel(element.ATTRNAME),
                        main_label: element.ATTRNAME,
                        value: element.ATTRVAL,
                      };
                      return (
                        <tr key={index}>
                          <td>
                            <div className="form-check d-flex align-items-center font-18">
                              <input
                                type="checkbox"
                                className="form-check-input  me-1"
                                id={index + "Row_Filter"}
                                checked={selectedValues[Helper.anythingToCamel(row.key)] ? true : false}
                                onChange={() => handleRowCheckboxChange(row)}
                              />
                            </div>
                          </td>
                          <td>
                            <label
                              className="form-check-label"
                              htmlFor={index + "Row_Filter"}
                            >
                              {element.ATTRNAME &&
                                true &&
                                element.ATTRNAME.trim() !== ""
                                ? element.ATTRNAME
                                : "-"}
                            </label>
                          </td>
                          <td>
                            {element.ATTRVAL &&
                              true &&
                              element.ATTRVAL.trim() !== ""
                              ? element.ATTRVAL
                              : "-"}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
            <button
              disabled={Object.keys(selectedValues).length === 0}
              onClick={() => {
                goToProductListing();
              }}
              className={Object.keys(selectedValues).length === 0 ? 'bs5 btn btn-secondary mt-3 mb-3 disabled' : 'bs5 btn btn-secondary mt-3 mb-3'}
            >
              find similar parts
            </button>
          </div>
        )}

        <div className="mt-1">
          {ECCNData?.length > 0 && (
            <>
              <h3 className="mb-3 mt-0 lh-normal"> ECCN / UNSPSC / COO</h3>
              <div className="table-respnsive">
                <table className="bs5 table table-bordered">
                  <thead>
                    <tr>
                      <th>
                        <span>Description</span>
                        <span
                          className={
                            "sort-container " + getOrderByClass("Name")
                          }
                          onClick={() => {
                            sortAttributes("Name");
                          }}
                        ></span>
                      </th>
                      <th>
                        <span>Value</span>
                        <span
                          className={
                            "sort-container " + getOrderByClass("Value")
                          }
                          onClick={() => {
                            sortAttributes("Value");
                          }}
                        ></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ECCNData?.map((v, i) => (
                      <tr key={i}>
                        <td>{v.Name}:</td>
                        <td>{v.Value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductDetailDescriptionTab;
